import { CaretDownOutlined } from '@ant-design/icons';
import {
  FILTER_TYPE,
  MODALITIES,
} from '@vindr/services/constants/study.constant';
import { DateRangePicker } from '@vindr/ui';
import { GENDER_OPTIONS } from '@vindr/ui/src/components/Templates/Select';
import { Input, Select } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import { FILTER_TYPE, MODALITIES } from './constants';

const { Option } = Select;

export enum StudylistFilters {
  STUDYDATE,
  PATIENT_ID,
  PATIENT_NAME,
  ORDER_GROUP,
  // STATUS,
  // INSTITUTION,
  VISIT_ID,
  PATIENT_SEX,
  BODY_PART,
  MODALITY,
  STUDY_DESC,
  // MATCH_STATUS,
}

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px]"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) =>
          handleOnChangeFilter(params, key, (event?.target as HTMLInputElement)?.value, true)
        }
        allowClear
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Study Date'),
        key: FILTER_TYPE.STUDYDATE,
        component: (
          <DateRangePicker
            size="small"
            value={[
              dayjs(params.study_date_from || new Date()),
              dayjs(params.study_date_to || new Date()),
            ]}
            onChange={(values: dayjs.Dayjs[]) => {
              handleOnChangeFilter(
                params,
                FILTER_TYPE.STUDYDATE,
                [values[0].startOf('days'), values[1].endOf('days')],
                true
              );
            }}
            allowClear
          />
        ),
      },
      {
        text: t('Patient ID'),
        key: FILTER_TYPE.PATIENT_ID,
        component: InputItem(params, FILTER_TYPE.PATIENT_ID, t('Enter Patient ID')),
      },

      {
        text: t('Patient Name'),
        key: FILTER_TYPE.PATIENT_NAME,
        component: InputItem(params, FILTER_TYPE.PATIENT_NAME, t('Enter Patient Name')),
      },
      {
        text: t('Order Group'),
        key: FILTER_TYPE.ORDER_GROUP,
        component: InputItem(params, FILTER_TYPE.ORDER_GROUP, t('Enter Order Group')),
      },
      // {
      //   text: t('Status'),
      //   key: FILTER_TYPE.STATUS,
      //   component: (
      //     <Select
      //       size="small"
      //       suffixIcon={<CaretDownOutlined />}
      //       placeholder={t('Select Status')}
      //       className="select-dropdown-light w-[200px]"
      //       popupClassName="dropdown-options-dark"
      //       onChange={(value) => {
      //         handleOnChangeFilter(params, FILTER_TYPE.STATUS, value, true);
      //       }}
      //       value={params[FILTER_TYPE.STATUS]}
      //       allowClear
      //     >
      //       <Option value={STUDYLIST_STATUS.NEW}>{t('NEW')}</Option>
      //       <Option value={STUDYLIST_STATUS.READING}>{t('READING')}</Option>
      //       <Option value={STUDYLIST_STATUS.APPROVED}>{t('APPROVED')}</Option>
      //       {/* <Option value="PENDING">{t('Pending')}</Option> */}
      //     </Select>
      //   ),
      // },
      // {
      //   text: t('Institution'),
      //   key: FILTER_TYPE.INSTITUTION,
      //   component: (
      //     <Filter.Institution
      //       size="small"
      //       multiple
      //       className="select-dropdown-light w-[200px]"
      //       popupClassName="dropdown-options-dark"
      //       onChange={(value) => {
      //         handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
      //       }}
      //       value={params[FILTER_TYPE.INSTITUTION] || []}
      //       filterOption={filterBothValueAndKey}
      //       title={false}
      //       allowClear
      //     />
      //   ),
      // },
      {
        text: t('Visit ID'),
        key: FILTER_TYPE.VISIT_ID,
        component: InputItem(params, FILTER_TYPE.VISIT_ID, t('Select Visit ID')),
      },
      {
        text: t('Gender'),
        key: FILTER_TYPE.PATIENT_SEX,
        component: (
          <Select
            size="small"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Gender')}
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.PATIENT_SEX, value, true);
            }}
            value={params[FILTER_TYPE.PATIENT_SEX]}
            options={GENDER_OPTIONS.map((gender) => ({ ...gender, label: t(gender.label) }))}
            allowClear
          />
        ),
      },
      /*  {
        text: t('Age'),
        key: FILTER_TYPE.PATIENT_AGE,
        component: InputItem(params, FILTER_TYPE.PATIENT_AGE),
      }, */
      // {
      //   text: t('CAD'),
      //   key: FILTER_TYPE.CAD,
      //   component: <Select
      //     size="small"
      //     style={{ width: '100%' }}
      //     suffixIcon={<CaretDownOutlined />}
      //     placeholder={t('Select')}
      //     className="select-dropdown-light w-[200px]"
      //     dropdownClassName="dropdown-options-dark"
      //     onChange={value => {
      //       handleOnChangeFilter(params, FILTER_TYPE.CAD, value, true);
      //     }}
      //     value={params[FILTER_TYPE.CAD] || null}
      //   >
      //     <Option value="*">{t('All')}</Option>
      //     <Option value="true">{t('Abnormal')}</Option>
      //     <Option value="false">{t('Normal')}</Option>
      //   </Select>
      // },
      {
        text: t('Body Part'),
        key: FILTER_TYPE.BODY_PART,
        component: InputItem(params, FILTER_TYPE.BODY_PART, t('Select Body Part')),
      },
      {
        text: t('Modality'),
        key: FILTER_TYPE.MODALITY,
        component: (
          <Select
            size="small"
            showSearch
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Modality')}
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.MODALITY, value, true);
            }}
            allowClear
            value={params[FILTER_TYPE.MODALITY] || null}
          >
            {MODALITIES.map((it) => (
              <Option key={it} value={it}>
                {it}
              </Option>
            ))}
          </Select>
        ),
      },
      {
        text: t('Study Description'),
        key: FILTER_TYPE.STUDY_DESC,
        component: InputItem(params, FILTER_TYPE.STUDY_DESC, t('Enter Study Description')),
      },
      // {
      //   text: t('Match Status'),
      //   key: FILTER_TYPE.MATCH_STATUS,
      //   component: (
      //     <Select
      //       size="small"
      //       suffixIcon={<CaretDownOutlined />}
      //       placeholder={t('Select Match Status')}
      //       className="select-dropdown-light w-[200px]"
      //       popupClassName="dropdown-options-dark"
      //       onChange={(value) => {
      //         handleOnChangeFilter(params, FILTER_TYPE.MATCH_STATUS, value, true);
      //       }}
      //       value={params[FILTER_TYPE.MATCH_STATUS]}
      //       allowClear
      //     >
      //       <Option value={MATCH_STATUS.Matched}>{t('Matched')}</Option>
      //       <Option value={MATCH_STATUS.Unmatched}>{t('Unmatched')}</Option>
      //     </Select>
      //   ),
      // },
      /*  {
        text: t('Approver Name'),
        key: FILTER_TYPE.APPROVER,
        component: InputItem(params, FILTER_TYPE.APPROVER),
      },
      {
        text: t('Procedure Code'),
        key: FILTER_TYPE.PROCEDURE_CODE,
        component: InputItem(params, FILTER_TYPE.PROCEDURE_CODE),
      },
      {
        text: t('Procedure Name'),
        key: FILTER_TYPE.PROCEDURE_NAME,
        component: InputItem(params, FILTER_TYPE.PROCEDURE_NAME),
      },
      {
        text: t('Order Doctor Name'),
        key: FILTER_TYPE.ORDER_DOCTOR,
        component: InputItem(params, FILTER_TYPE.ORDER_DOCTOR),
      },
      {
        text: t('Refer Doctor Name'),
        key: FILTER_TYPE.REFER_DOCTOR,
        component: InputItem(params, FILTER_TYPE.REFER_DOCTOR),
      },
      {
        text: t('Diagnosis'),
        key: FILTER_TYPE.DIAGNOSIS,
        component: InputItem(params, FILTER_TYPE.DIAGNOSIS),
      }, */
    ],
    [t, params, open, handleOnChangeFilter]
  );
};

export default useSearchOptions;
